(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EVM", [], factory);
	else if(typeof exports === 'object')
		exports["EVM"] = factory();
	else
		root["EVM"] = factory();
})(window, function() {
return 